import styles from './style.postcss';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { replace } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'omni-common-ui';
import {
  coreActions,
  spinActions,
  accessors,
} from 'data/WritingAssignment';

import { TABS, writingAssignmentRootPath, LESSON_CATEGORY } from './routes';

export class WritingAssignment extends Component {

  componentWillMount() {
    this._fetchWrittingAssignmentIfNeed(this.props);
    if (this.props.pathname.endsWith(writingAssignmentRootPath)) {
      this._redirectTo();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pathname.endsWith(writingAssignmentRootPath)) {
      this._redirectTo();
    }
  }

  _redirectTo() {
    const { groupId, replacehRoute, buildRoute } = this.props;

    replacehRoute(buildRoute(
      `/group/${groupId}/${writingAssignmentRootPath}/${TABS[LESSON_CATEGORY.CORE_CATCH_UP]}`));
  }

  _fetchWrittingAssignmentIfNeed(props) {
    const { groupId } = props;
    props.fetchCoreWrittingAssignmentIfNeed(groupId);
    props.fetchSPINWrittingAssignmentIfNeed(groupId);
  }

  render() {
    const {
      coreWritingAssignmentList,
      spinWritingAssignmentList,
    } = this.props;
    if (coreWritingAssignmentList && spinWritingAssignmentList) {
      return <div className={styles.WritingAssignment_container}>
        {this.props.children}
      </div>;
    }
    return null;
  }
}

WritingAssignment.propTypes = {
  groupId: PropTypes.string,
  pathname: PropTypes.string,
  children: PropTypes.node,
  replacehRoute: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  fetchWrittingAssignmentIfNeed: PropTypes.func,
  coreWritingAssignmentList: PropTypes.object,
  spinWritingAssignmentList: PropTypes.object,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const { pathname } = ownProps.location;
  const coreWritingAssignmentList = accessors.getCoreWritingAssignment(state, groupId);
  const spinWritingAssignmentList = accessors.getSPINWritingAssignment(state, groupId);

  return {
    groupId,
    pathname,
    coreWritingAssignmentList,
    spinWritingAssignmentList,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { replacehRoute: (path) => dispatch(replace(path)) },
    bindActionCreators(coreActions, dispatch),
    bindActionCreators(spinActions, dispatch),
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(WritingAssignment);



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/component.jsx